import React from "react"
import { Grid, Typography, useMediaQuery } from "@mui/material"
import CheckBoxTwoToneIcon from "@mui/icons-material/CheckBoxTwoTone"
import CheckBoxOutlineBlankTwoToneIcon from "@mui/icons-material/CheckBoxOutlineBlankTwoTone"
import ChatTwoToneIcon from "@mui/icons-material/ChatTwoTone"
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone"

const IconLegend = ({ isMobile }) => {
  const marginIconText = isMobile ? 0.5 : 1
  const iconSize = isMobile ? "small" : "medium"
  const textSize = isMobile ? "caption" : "body2"

  const isSmall = useMediaQuery("(max-width:412px)")
  const isVerySmall = useMediaQuery("(max-width:350)")
  const isInBetween = isSmall && !isVerySmall

  // todo blyat
  const LEFT_UP_COL_WIDTH = isInBetween ? 6 : 5
  const RIGHT_UP_COL_WIDTH = isInBetween ? 6 : 7
  const LEFT_DOWN_COL_WIDTH = LEFT_UP_COL_WIDTH
  const RIGHT_DOWN_COL_WIDTH = RIGHT_UP_COL_WIDTH
  // const LEFT_DOWN_COL_WIDTH = isInBetween ? 5 : 5
  // const RIGHT_DOWN_COL_WIDTH = isInBetween ? 7 : 7

  return (
    <Grid sx={{ pt: 1 }} container direction="row" spacing={isMobile ? 1 : 4}>
      <Grid item xs={isMobile ? LEFT_UP_COL_WIDTH : "auto"} container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
        <CheckBoxOutlineBlankTwoToneIcon fontSize={iconSize} />
        <Typography variant={textSize} sx={{ ml: marginIconText }}>
          Buch nicht eingestellt
        </Typography>
      </Grid>
      <Grid item xs={isMobile ? RIGHT_UP_COL_WIDTH : "auto"} container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
        <SearchTwoToneIcon fontSize={iconSize} />
        <Typography variant={textSize} sx={{ ml: marginIconText }}>
          Partner wird gesucht
        </Typography>
      </Grid>
      <Grid item xs={isMobile ? LEFT_DOWN_COL_WIDTH : "auto"} container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
        <ChatTwoToneIcon fontSize={iconSize} sx={{ color: "primary.main" }} />
        <Typography variant={textSize} sx={{ ml: marginIconText }}>
          Partner gefunden
        </Typography>
      </Grid>
      <Grid item xs={isMobile ? RIGHT_DOWN_COL_WIDTH : "auto"} container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
        <CheckBoxTwoToneIcon fontSize={iconSize} />
        <Typography variant={textSize} sx={{ ml: marginIconText }}>
          Kauf / Verkauf abgeschlossen
        </Typography>
      </Grid>
    </Grid>
  )
}

export default IconLegend
